// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__O3aib","AppLight":"App_AppLight__g7CnA App_App__O3aib","AppDark":"App_AppDark__1jWZD App_App__O3aib"};